import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M3 2H11C12.3063 2 13.4175 2.83485 13.8293 4.00009L19 4C20.5977 4 21.9037 5.24892 21.9949 6.82373L22 7V15C22 16.5977 20.7511 17.9037 19.1763 17.9949L19 18H15C13.6941 18 12.5831 17.1656 12.171 16.0009L4 16V21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V3C2 2.44772 2.44772 2 3 2ZM14 6V15C14 15.5128 14.386 15.9355 14.8834 15.9933L15 16H19C19.5128 16 19.9355 15.614 19.9933 15.1166L20 15V7C20 6.48716 19.614 6.06449 19.1166 6.00673L19 6H14ZM11 4H4V14H12V5C12 4.48716 11.614 4.06449 11.1166 4.00673L11 4Z" />,
  'Flag'
);
